module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.original ? _vm.$t('profile.certForm.titleUpdate') : _vm.$t('profile.certForm.titleAdd')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-switch', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$t('headers.enabled')
    },
    model: {
      value: (_vm.enabled),
      callback: function($$v) {
        _vm.enabled = $$v
      },
      expression: "enabled"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.original === null),
      expression: "original === null"
    }]
  }, [_c('v-text-field', {
    attrs: {
      "label": "Klíč",
      "multi-line": "",
      "rules": _vm.keyRules
    },
    model: {
      value: (_vm.certificate),
      callback: function($$v) {
        _vm.certificate = $$v
      },
      expression: "certificate"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "loading": _vm.isBusy
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef83a82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/CertificateForm.vue
// module id = 1069
// module chunks = 1